export default __webpack_public_path__ + "static/media/whatsapp.3cf8890c.svg";